import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/base.css'
import moment from 'moment'
import VueAMap from 'vue-amap'
import _ from 'lodash'
import * as api from './api'
import * as validate from './util/validate.js'
import * as util from './util/util.js'
import Avue from '@smallwei/avue'
import '@smallwei/avue/lib/index.css'

Vue.prototype.$api = api
Vue.prototype.$validate = validate
Vue.prototype.$util = util
Vue.prototype.$moment = moment
Vue.prototype.$origin = process.env.NODE_ENV === 'development' ? 'http://192.168.50.46' : window.location.origin
Vue.prototype.$_ = _
Vue.use(ElementUI)
Vue.use(Avue)
Vue.use(VueAMap)

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
